import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'

const COOKIE_FEEDBACK = 'FEEDBACK_PANEL'

const FeedBackButton = () => {
  const [isOpen, setOpen] = useState()

  useEffect(() => {
    setOpen(Cookies.get(COOKIE_FEEDBACK) === 'false' ? false : true)
  }, [])

  const handleClick = () => {
    setOpen(false)
    setFeedback(false)
    window.open('https://t.me/RuptlySupport', '_blank', 'noopener,noreferrer')
  }

  const handleCloseClick = () => {
    setOpen(false)
    setFeedback(false)
  }

  const setFeedback = value => {
    Cookies.set(COOKIE_FEEDBACK, value, { expires: 365 })
  }

  return (
    <div className="feedback">
      {isOpen && (
        <div className="feedback-panel">
          Есть вопросы? Напишите нам
          <div className="size-2 bg-viory-white absolute ltr:-right-1 rtl:-left-1 top-[50%] -mt-1 rotate-45"></div>
          <button onClick={handleCloseClick} className="close-button">
            <div className="icon-close" />
          </button>
          <div className="panel-coner" />
        </div>
      )}
      <button onClick={handleClick} className="feedback-button">
        <div className="icon-message" />
      </button>
    </div>
  )
}

export default FeedBackButton
